
//const MASTER_STATUS_NO_MESSAGE = 0;
// Wenn weder OFF (aus) noch RUN (aktiv), dann ist die Verbundsteuerung inaktiv
const MASTER_STATUS_OFF_MASK = 0x0001;	// Off (d.h. Verbundsteuerung ist aus)
const MASTER_STATUS_RUN_MASK = 0x0002;	// Run (d.h. Verbundsteuerung ist aktiv)

const MASTER_DISPLAYED_STATUS_OFF = 0;
const MASTER_DISPLAYED_STATUS_INACTIVE = 1;
const MASTER_DISPLAYED_STATUS_ACTIVE = 2;

const masterDisplayedStatusIndex = master => {
	if (master.status & MASTER_STATUS_RUN_MASK) {
		return MASTER_DISPLAYED_STATUS_ACTIVE;
	} else if (master.status & MASTER_STATUS_OFF_MASK) {
		return MASTER_DISPLAYED_STATUS_OFF;
	}
	return MASTER_DISPLAYED_STATUS_INACTIVE;
};

export const masterDisplayedStatusTNR = master => (
	[ "Off", "Inactive", "Active"][
		masterDisplayedStatusIndex(master)]
);
